import { useNavigate } from "react-router-dom";
import {
  APP_SUBDOMAIN_PREFIX,
  domain,
  shouldNotUseSubDomain,
} from "../utils/constants";

export const useWebsiteButton = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    if (shouldNotUseSubDomain) {
      navigate("/login");
    } else {
      window.location.href = `https://${APP_SUBDOMAIN_PREFIX}${domain}/login`;
    }
  };

  const goToSignup = () => {
    if (shouldNotUseSubDomain) {
      navigate("/signup");
    } else {
      window.location.href = `https://${APP_SUBDOMAIN_PREFIX}${domain}/signup`;
    }
  };

  const goToProfile = () => {
    if (shouldNotUseSubDomain) {
      navigate("/settings");
    } else {
      window.location.href = `https://${APP_SUBDOMAIN_PREFIX}${domain}/settings`;
    }
  };

  const goToDashboard = () => {
    if (shouldNotUseSubDomain) {
      navigate("/home");
    } else {
      window.location.href = `https://${APP_SUBDOMAIN_PREFIX}${domain}/home`;
    }
  };

  return { goToLogin, goToSignup, goToProfile, goToDashboard };
};
